export const MOCK_GIFTS = [
  { id: 1, name: "Delicious Cake", icon: "🎂", price: 0.5, category: "food" },
  { id: 2, name: "Green Star", icon: "⭐", price: 1.0, category: "premium" },
  { id: 3, name: "Blue Star", icon: "💠", price: 2.5, category: "premium" },
  { id: 4, name: "Red Star", icon: "🔴", price: 5.0, category: "premium" },
  { id: 5, name: "Tropical Flower", icon: "🌺", price: 0.3, category: "nature" },
  { id: 6, name: "Golden Crown", icon: "👑", price: 10.0, category: "luxury" },
  { id: 7, name: "Diamond", icon: "💎", price: 15.0, category: "luxury" },
  { id: 8, name: "Rose", icon: "🌹", price: 0.8, category: "nature" },
  { id: 9, name: "Fire", icon: "🔥", price: 3.5, category: "special" },
  { id: 10, name: "Rainbow", icon: "🌈", price: 7.0, category: "special" },
];

export const GAME_STATUS = {
  WAITING: 'waiting',
  COUNTDOWN: 'countdown',
  SPINNING: 'spinning',
  RESULT: 'result',
  FINISHED: 'finished'
};

export const WS_MESSAGES = {
  CONNECT: 'CONNECT',
  CONNECTED: 'CONNECTED',
  PLACE_GIFT: 'PLACE_GIFT',
  GET_GAME_STATE: 'GET_GAME_STATE',
  GET_HISTORY: 'GET_HISTORY',
  GET_INVENTORY: 'GET_INVENTORY',
  GAME_UPDATED: 'GAME_UPDATED',
  GAME_STATE: 'GAME_STATE',
  COUNTDOWN_UPDATE: 'COUNTDOWN_UPDATE',
  GAME_START: 'GAME_START',
  GAME_RESULT: 'GAME_RESULT',
  NEW_GAME: 'NEW_GAME',
  HISTORY: 'HISTORY',
  INVENTORY: 'INVENTORY',
  ERROR: 'ERROR'
};

export const ANIMATION_TIMINGS = {
  FAST_ACCELERATION: 5000,     // 0-5 sec
  SLIGHT_DECELERATION: 3000,   // 5-8 sec
  SMOOTH_DECELERATION: 3000,   // 8-11 sec
  TOTAL_DURATION: 11000,       // 11 sec total
  RESULT_DISPLAY: 5000         // 5 sec display
};